
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.ts'
export type * from './prismaNamespace.ts'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.NullTypes.DbNull as (new (secret: never) => typeof runtime.DbNull),
  JsonNull: runtime.NullTypes.JsonNull as (new (secret: never) => typeof runtime.JsonNull),
  AnyNull: runtime.NullTypes.AnyNull as (new (secret: never) => typeof runtime.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.DbNull

/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.JsonNull

/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.AnyNull


export const ModelName = {
  User: 'User',
  UserCalcHistory: 'UserCalcHistory',
  UserCalcBookmark: 'UserCalcBookmark',
  CalcParams: 'CalcParams',
  CRMDetails: 'CRMDetails',
  PowerBIBookmark: 'PowerBIBookmark',
  UserEvent: 'UserEvent',
  SubscriptionInstanceEventDetails: 'SubscriptionInstanceEventDetails',
  DemoEventDetails: 'DemoEventDetails',
  TrialEventDetails: 'TrialEventDetails',
  SignUpEventDetails: 'SignUpEventDetails',
  UserDetailsEventDetails: 'UserDetailsEventDetails',
  InvitationEventDetails: 'InvitationEventDetails',
  OpportunityStatusEventDetails: 'OpportunityStatusEventDetails',
  Company: 'Company',
  Address: 'Address',
  Team: 'Team',
  ApiInstance: 'ApiInstance',
  FreightMatrixDefinitionOverride: 'FreightMatrixDefinitionOverride',
  ApiKeys: 'ApiKeys',
  ApiPermissions: 'ApiPermissions',
  ApiRequestLog: 'ApiRequestLog',
  ApiRateLimits: 'ApiRateLimits',
  TeamCRMDetails: 'TeamCRMDetails',
  CommentInstance: 'CommentInstance',
  InvoiceInformation: 'InvoiceInformation',
  TransactionInstance: 'TransactionInstance',
  SubscriptionPriceInstance: 'SubscriptionPriceInstance',
  PlatformSubscriptionPriceInstance: 'PlatformSubscriptionPriceInstance',
  DefaultSubscriptionPrice: 'DefaultSubscriptionPrice',
  SubscriptionTemplate: 'SubscriptionTemplate',
  SubscriptionFeatureLimit: 'SubscriptionFeatureLimit',
  SubscriptionInstance: 'SubscriptionInstance',
  SubscriptionRequestInstance: 'SubscriptionRequestInstance',
  SlackMessage: 'SlackMessage',
  Invitation: 'Invitation',
  PermissionTemplate: 'PermissionTemplate',
  PermissionInstance: 'PermissionInstance',
  PermissionInternalTemplate: 'PermissionInternalTemplate',
  PermissionInternalInstance: 'PermissionInternalInstance',
  VerificationToken: 'VerificationToken',
  PasswordResetToken: 'PasswordResetToken',
  LoginOtpToken: 'LoginOtpToken',
  LoginAttempt: 'LoginAttempt',
  Country: 'Country',
  Port: 'Port',
  LocationCollection: 'LocationCollection',
  LocationCollectionList: 'LocationCollectionList',
  IncoParity: 'IncoParity',
  Product: 'Product',
  MarketReportTemplate: 'MarketReportTemplate',
  MarketReportTemplateGenerationTemplateHistory: 'MarketReportTemplateGenerationTemplateHistory',
  MarketReportInstance: 'MarketReportInstance',
  MarketReportPublicShare: 'MarketReportPublicShare',
  MarketReportGroup: 'MarketReportGroup',
  MarketReportGroupPriority: 'MarketReportGroupPriority',
  SelfCheckoutPlatformSubscriptionPrice: 'SelfCheckoutPlatformSubscriptionPrice',
  MarketReportGroupPrice: 'MarketReportGroupPrice',
  MarketReportEmailPreference: 'MarketReportEmailPreference',
  NewsContentCategory: 'NewsContentCategory',
  MarketCommentary: 'MarketCommentary',
  News: 'News',
  MarketEvent: 'MarketEvent',
  ExchangeMarket: 'ExchangeMarket',
  FutureContractInstance: 'FutureContractInstance',
  FutureInstance: 'FutureInstance',
  Currency: 'Currency',
  ExchangeRateInstance: 'ExchangeRateInstance',
  ProductVariant: 'ProductVariant',
  ProductHierachy: 'ProductHierachy',
  ProductHierachyInstance: 'ProductHierachyInstance',
  DocumentRequirement: 'DocumentRequirement',
  QualityRequirement: 'QualityRequirement',
  BidOfferInstance: 'BidOfferInstance',
  BidOfferPremiumUpdate: 'BidOfferPremiumUpdate',
  BidOfferFlatUpdate: 'BidOfferFlatUpdate',
  PremiumPriceInstance: 'PremiumPriceInstance',
  FlatPriceInstance: 'FlatPriceInstance',
  MeasurementUnit: 'MeasurementUnit',
  BasePortAreas: 'BasePortAreas',
  BasePortDiff: 'BasePortDiff',
  D365CrmCustomer: 'D365CrmCustomer',
  NominalPriceUploadInstance: 'NominalPriceUploadInstance',
  NominalPriceInstance: 'NominalPriceInstance',
  NominalPricePremiumInstance: 'NominalPricePremiumInstance',
  NominalPriceFlatInstance: 'NominalPriceFlatInstance',
  FreightQuoteRequests: 'FreightQuoteRequests',
  FreightQuoteRequestParamSet: 'FreightQuoteRequestParamSet',
  FreightQuoteRequestPort: 'FreightQuoteRequestPort',
  FreightQuoteRequestOperation: 'FreightQuoteRequestOperation',
  FreightMatrixRoute: 'FreightMatrixRoute',
  FreightCalculationMatrixGroup: 'FreightCalculationMatrixGroup',
  FreightCalculationMatrixGroupInclude: 'FreightCalculationMatrixGroupInclude',
  FreightCalculationMatrixGroupItem: 'FreightCalculationMatrixGroupItem',
  FreightMatrixJob: 'FreightMatrixJob',
  FreightMatrixPartialJob: 'FreightMatrixPartialJob',
  SelectPinnedItem: 'SelectPinnedItem',
  WhatsappConnection: 'WhatsappConnection',
  Notification: 'Notification',
  NotificationInstance: 'NotificationInstance',
  NotificationChannel: 'NotificationChannel',
  EntityACL: 'EntityACL',
  LineupAgent: 'LineupAgent',
  CropYearDefinition: 'CropYearDefinition',
  CropYear: 'CropYear',
  LineupInstance: 'LineupInstance',
  LineupString: 'LineupString',
  LineupHistory: 'LineupHistory',
  DataJobs: 'DataJobs',
  FeatureFlags: 'FeatureFlags',
  FeatureFlagTeamTarget: 'FeatureFlagTeamTarget',
  FeatureFlagUserTarget: 'FeatureFlagUserTarget',
  PaymentCustomer: 'PaymentCustomer',
  SelfCheckoutSubscription: 'SelfCheckoutSubscription',
  SelfCheckoutSubscriptionItem: 'SelfCheckoutSubscriptionItem',
  SubscriptionChange: 'SubscriptionChange',
  PaymentProviderProductMapping: 'PaymentProviderProductMapping',
  PaymentProviderSubscriptionData: 'PaymentProviderSubscriptionData',
  PaymentProviderWebhookEvent: 'PaymentProviderWebhookEvent',
  AuditLog: 'AuditLog',
  FormSubmissions: 'FormSubmissions',
  SupplyDemand: 'SupplyDemand',
  SupplyDemandAttribute: 'SupplyDemandAttribute',
  SupplyDemandUpload: 'SupplyDemandUpload'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  lastActive: 'lastActive',
  agreementDate: 'agreementDate',
  onboardingStatus: 'onboardingStatus',
  trackingId: 'trackingId',
  blocked: 'blocked',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  countryId: 'countryId',
  role: 'role',
  teamRole: 'teamRole',
  teamId: 'teamId',
  companyId: 'companyId',
  email: 'email',
  emailVerified: 'emailVerified',
  welcomeEmailSent: 'welcomeEmailSent',
  passwordExpiry: 'passwordExpiry',
  password: 'password',
  responsibleSalesPersonId: 'responsibleSalesPersonId',
  leadSource: 'leadSource',
  spamScore: 'spamScore',
  timezoneOffsetFromUTC: 'timezoneOffsetFromUTC',
  technicalAnalysisWorkspace: 'technicalAnalysisWorkspace'
} as const

export type UserScalarFieldEnum = (typeof UserScalarFieldEnum)[keyof typeof UserScalarFieldEnum]


export const UserCalcHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  paramsHash: 'paramsHash'
} as const

export type UserCalcHistoryScalarFieldEnum = (typeof UserCalcHistoryScalarFieldEnum)[keyof typeof UserCalcHistoryScalarFieldEnum]


export const UserCalcBookmarkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  userId: 'userId',
  paramsHash: 'paramsHash'
} as const

export type UserCalcBookmarkScalarFieldEnum = (typeof UserCalcBookmarkScalarFieldEnum)[keyof typeof UserCalcBookmarkScalarFieldEnum]


export const CalcParamsScalarFieldEnum = {
  hash: 'hash',
  createdAt: 'createdAt',
  parameters: 'parameters'
} as const

export type CalcParamsScalarFieldEnum = (typeof CalcParamsScalarFieldEnum)[keyof typeof CalcParamsScalarFieldEnum]


export const CRMDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  jobTitle: 'jobTitle',
  d365Link: 'd365Link',
  attioLink: 'attioLink',
  mixPanelLink: 'mixPanelLink',
  businessPhone: 'businessPhone',
  directPhone: 'directPhone',
  mobilePhone: 'mobilePhone',
  privatePhone: 'privatePhone',
  department: 'department',
  churnRisk: 'churnRisk',
  origin: 'origin',
  opportunityStatus: 'opportunityStatus',
  opportunityEstimatedRevenue: 'opportunityEstimatedRevenue'
} as const

export type CRMDetailsScalarFieldEnum = (typeof CRMDetailsScalarFieldEnum)[keyof typeof CRMDetailsScalarFieldEnum]


export const PowerBIBookmarkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  bookmarkId: 'bookmarkId',
  bookmarkName: 'bookmarkName',
  bookmarkUrl: 'bookmarkUrl',
  bookmarkState: 'bookmarkState'
} as const

export type PowerBIBookmarkScalarFieldEnum = (typeof PowerBIBookmarkScalarFieldEnum)[keyof typeof PowerBIBookmarkScalarFieldEnum]


export const UserEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  description: 'description',
  rejectionReason: 'rejectionReason',
  type: 'type',
  demoEventDetailsId: 'demoEventDetailsId',
  trialEventDetailsId: 'trialEventDetailsId',
  signUpEventDetailsId: 'signUpEventDetailsId',
  invitationEventDetailsId: 'invitationEventDetailsId',
  userDetailsEventDetailsId: 'userDetailsEventDetailsId',
  opportunityStatusEventDetailsId: 'opportunityStatusEventDetailsId',
  subscriptionInstanceEventDetailsId: 'subscriptionInstanceEventDetailsId',
  userId: 'userId'
} as const

export type UserEventScalarFieldEnum = (typeof UserEventScalarFieldEnum)[keyof typeof UserEventScalarFieldEnum]


export const SubscriptionInstanceEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionInstanceId: 'subscriptionInstanceId'
} as const

export type SubscriptionInstanceEventDetailsScalarFieldEnum = (typeof SubscriptionInstanceEventDetailsScalarFieldEnum)[keyof typeof SubscriptionInstanceEventDetailsScalarFieldEnum]


export const DemoEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  start: 'start',
  end: 'end',
  notes: 'notes',
  salesPersonId: 'salesPersonId'
} as const

export type DemoEventDetailsScalarFieldEnum = (typeof DemoEventDetailsScalarFieldEnum)[keyof typeof DemoEventDetailsScalarFieldEnum]


export const TrialEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  start: 'start',
  end: 'end',
  notes: 'notes',
  salesPersonId: 'salesPersonId'
} as const

export type TrialEventDetailsScalarFieldEnum = (typeof TrialEventDetailsScalarFieldEnum)[keyof typeof TrialEventDetailsScalarFieldEnum]


export const SignUpEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  notes: 'notes'
} as const

export type SignUpEventDetailsScalarFieldEnum = (typeof SignUpEventDetailsScalarFieldEnum)[keyof typeof SignUpEventDetailsScalarFieldEnum]


export const UserDetailsEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  notes: 'notes'
} as const

export type UserDetailsEventDetailsScalarFieldEnum = (typeof UserDetailsEventDetailsScalarFieldEnum)[keyof typeof UserDetailsEventDetailsScalarFieldEnum]


export const InvitationEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  notes: 'notes',
  sentById: 'sentById'
} as const

export type InvitationEventDetailsScalarFieldEnum = (typeof InvitationEventDetailsScalarFieldEnum)[keyof typeof InvitationEventDetailsScalarFieldEnum]


export const OpportunityStatusEventDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  previousStatus: 'previousStatus',
  newStatus: 'newStatus',
  updatedByUserId: 'updatedByUserId',
  notes: 'notes'
} as const

export type OpportunityStatusEventDetailsScalarFieldEnum = (typeof OpportunityStatusEventDetailsScalarFieldEnum)[keyof typeof OpportunityStatusEventDetailsScalarFieldEnum]


export const CompanyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  industry: 'industry',
  size: 'size',
  businessSector: 'businessSector',
  country: 'country'
} as const

export type CompanyScalarFieldEnum = (typeof CompanyScalarFieldEnum)[keyof typeof CompanyScalarFieldEnum]


export const AddressScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  street: 'street',
  city: 'city',
  postalCode: 'postalCode',
  countryId: 'countryId'
} as const

export type AddressScalarFieldEnum = (typeof AddressScalarFieldEnum)[keyof typeof AddressScalarFieldEnum]


export const TeamScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  subscriptionDuration: 'subscriptionDuration',
  apiPrice: 'apiPrice',
  freightMatrixRouteLimit: 'freightMatrixRouteLimit'
} as const

export type TeamScalarFieldEnum = (typeof TeamScalarFieldEnum)[keyof typeof TeamScalarFieldEnum]


export const ApiInstanceScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  description: 'description',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt'
} as const

export type ApiInstanceScalarFieldEnum = (typeof ApiInstanceScalarFieldEnum)[keyof typeof ApiInstanceScalarFieldEnum]


export const FreightMatrixDefinitionOverrideScalarFieldEnum = {
  teamId: 'teamId',
  order: 'order',
  name: 'name',
  source: 'source',
  eval: 'eval',
  format: 'format',
  literalNull: 'literalNull'
} as const

export type FreightMatrixDefinitionOverrideScalarFieldEnum = (typeof FreightMatrixDefinitionOverrideScalarFieldEnum)[keyof typeof FreightMatrixDefinitionOverrideScalarFieldEnum]


export const ApiKeysScalarFieldEnum = {
  id: 'id',
  apikey: 'apikey',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  apiInstanceId: 'apiInstanceId'
} as const

export type ApiKeysScalarFieldEnum = (typeof ApiKeysScalarFieldEnum)[keyof typeof ApiKeysScalarFieldEnum]


export const ApiPermissionsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  apiInstanceId: 'apiInstanceId',
  key: 'key',
  filter: 'filter'
} as const

export type ApiPermissionsScalarFieldEnum = (typeof ApiPermissionsScalarFieldEnum)[keyof typeof ApiPermissionsScalarFieldEnum]


export const ApiRequestLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  apiInstanceId: 'apiInstanceId',
  url: 'url',
  method: 'method',
  encodingHeader: 'encodingHeader',
  acceptHeader: 'acceptHeader',
  authorizationHeader: 'authorizationHeader',
  statusCode: 'statusCode',
  durationMs: 'durationMs',
  firstPartOfResponse: 'firstPartOfResponse',
  errors: 'errors',
  requestSize: 'requestSize',
  noOfRecords: 'noOfRecords',
  onBehalfOf: 'onBehalfOf',
  ip: 'ip'
} as const

export type ApiRequestLogScalarFieldEnum = (typeof ApiRequestLogScalarFieldEnum)[keyof typeof ApiRequestLogScalarFieldEnum]


export const ApiRateLimitsScalarFieldEnum = {
  id: 'id',
  fk_apiKey: 'fk_apiKey',
  minutes: 'minutes',
  requests: 'requests'
} as const

export type ApiRateLimitsScalarFieldEnum = (typeof ApiRateLimitsScalarFieldEnum)[keyof typeof ApiRateLimitsScalarFieldEnum]


export const TeamCRMDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  teamId: 'teamId',
  d365Link: 'd365Link',
  attioLink: 'attioLink',
  mixPanelLink: 'mixPanelLink',
  d365CustomerNo: 'd365CustomerNo',
  companyName: 'companyName',
  companyVatNumber: 'companyVatNumber',
  businessSector: 'businessSector',
  companyAddressId: 'companyAddressId',
  invoiceReferenceName: 'invoiceReferenceName',
  invoiceReferenceEmail: 'invoiceReferenceEmail',
  preferredCurrency: 'preferredCurrency',
  preferredLanguage: 'preferredLanguage'
} as const

export type TeamCRMDetailsScalarFieldEnum = (typeof TeamCRMDetailsScalarFieldEnum)[keyof typeof TeamCRMDetailsScalarFieldEnum]


export const CommentInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  body: 'body',
  createdById: 'createdById',
  userId: 'userId',
  teamId: 'teamId',
  bidOfferInstanceId: 'bidOfferInstanceId'
} as const

export type CommentInstanceScalarFieldEnum = (typeof CommentInstanceScalarFieldEnum)[keyof typeof CommentInstanceScalarFieldEnum]


export const InvoiceInformationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invoiceEmail: 'invoiceEmail',
  teamId: 'teamId',
  invoicingType: 'invoicingType',
  name: 'name',
  vatNumber: 'vatNumber',
  addressId: 'addressId'
} as const

export type InvoiceInformationScalarFieldEnum = (typeof InvoiceInformationScalarFieldEnum)[keyof typeof InvoiceInformationScalarFieldEnum]


export const TransactionInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  totalAmount: 'totalAmount',
  discountedAmount: 'discountedAmount',
  discountPercentage: 'discountPercentage',
  companyName: 'companyName',
  companyVatNumber: 'companyVatNumber',
  companyAddressId: 'companyAddressId',
  status: 'status',
  createdByUserId: 'createdByUserId',
  approvedByUserId: 'approvedByUserId',
  teamId: 'teamId'
} as const

export type TransactionInstanceScalarFieldEnum = (typeof TransactionInstanceScalarFieldEnum)[keyof typeof TransactionInstanceScalarFieldEnum]


export const SubscriptionPriceInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  price: 'price',
  subscriptionTemplateId: 'subscriptionTemplateId',
  teamId: 'teamId'
} as const

export type SubscriptionPriceInstanceScalarFieldEnum = (typeof SubscriptionPriceInstanceScalarFieldEnum)[keyof typeof SubscriptionPriceInstanceScalarFieldEnum]


export const PlatformSubscriptionPriceInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  price: 'price',
  subscriptionTemplateId: 'subscriptionTemplateId',
  teamId: 'teamId'
} as const

export type PlatformSubscriptionPriceInstanceScalarFieldEnum = (typeof PlatformSubscriptionPriceInstanceScalarFieldEnum)[keyof typeof PlatformSubscriptionPriceInstanceScalarFieldEnum]


export const DefaultSubscriptionPriceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  userPrice: 'userPrice',
  basePrice: 'basePrice',
  duration: 'duration',
  subscriptionTemplateId: 'subscriptionTemplateId'
} as const

export type DefaultSubscriptionPriceScalarFieldEnum = (typeof DefaultSubscriptionPriceScalarFieldEnum)[keyof typeof DefaultSubscriptionPriceScalarFieldEnum]


export const SubscriptionTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  note: 'note',
  isTrial: 'isTrial',
  menuVariant: 'menuVariant',
  menuSortOrder: 'menuSortOrder'
} as const

export type SubscriptionTemplateScalarFieldEnum = (typeof SubscriptionTemplateScalarFieldEnum)[keyof typeof SubscriptionTemplateScalarFieldEnum]


export const SubscriptionFeatureLimitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionTemplateId: 'subscriptionTemplateId',
  featureKey: 'featureKey',
  limitType: 'limitType',
  limitValue: 'limitValue'
} as const

export type SubscriptionFeatureLimitScalarFieldEnum = (typeof SubscriptionFeatureLimitScalarFieldEnum)[keyof typeof SubscriptionFeatureLimitScalarFieldEnum]


export const SubscriptionInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  note: 'note',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',
  userId: 'userId',
  teamId: 'teamId',
  monthlyPrice: 'monthlyPrice',
  discountedAmount: 'discountedAmount',
  discountPercentage: 'discountPercentage',
  subscriptionTemplateId: 'subscriptionTemplateId',
  transactionInstanceId: 'transactionInstanceId',
  selfCheckoutSubscriptionItemId: 'selfCheckoutSubscriptionItemId',
  renewalStatus: 'renewalStatus',
  invoiceNumber: 'invoiceNumber',
  invoiceDate: 'invoiceDate',
  invoiceStatus: 'invoiceStatus',
  nextSubscriptionId: 'nextSubscriptionId'
} as const

export type SubscriptionInstanceScalarFieldEnum = (typeof SubscriptionInstanceScalarFieldEnum)[keyof typeof SubscriptionInstanceScalarFieldEnum]


export const SubscriptionRequestInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  status: 'status',
  note: 'note',
  userId: 'userId',
  reviewedById: 'reviewedById',
  subscriptionTemplateId: 'subscriptionTemplateId',
  eventHistory: 'eventHistory'
} as const

export type SubscriptionRequestInstanceScalarFieldEnum = (typeof SubscriptionRequestInstanceScalarFieldEnum)[keyof typeof SubscriptionRequestInstanceScalarFieldEnum]


export const SlackMessageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  entityType: 'entityType',
  entityId: 'entityId',
  messageType: 'messageType',
  channelId: 'channelId',
  messageTs: 'messageTs',
  threadTs: 'threadTs',
  status: 'status'
} as const

export type SlackMessageScalarFieldEnum = (typeof SlackMessageScalarFieldEnum)[keyof typeof SlackMessageScalarFieldEnum]


export const InvitationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  invitedUserId: 'invitedUserId',
  email: 'email',
  token: 'token',
  expires: 'expires',
  status: 'status',
  subscriptionTemplateId: 'subscriptionTemplateId',
  teamId: 'teamId',
  sentById: 'sentById'
} as const

export type InvitationScalarFieldEnum = (typeof InvitationScalarFieldEnum)[keyof typeof InvitationScalarFieldEnum]


export const PermissionTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayName: 'displayName',
  type: 'type',
  powerbi_report_section_id: 'powerbi_report_section_id'
} as const

export type PermissionTemplateScalarFieldEnum = (typeof PermissionTemplateScalarFieldEnum)[keyof typeof PermissionTemplateScalarFieldEnum]


export const PermissionInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  note: 'note',
  startDate: 'startDate',
  endDate: 'endDate',
  level: 'level',
  status: 'status',
  permissionTemplateId: 'permissionTemplateId',
  userId: 'userId'
} as const

export type PermissionInstanceScalarFieldEnum = (typeof PermissionInstanceScalarFieldEnum)[keyof typeof PermissionInstanceScalarFieldEnum]


export const PermissionInternalTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayName: 'displayName'
} as const

export type PermissionInternalTemplateScalarFieldEnum = (typeof PermissionInternalTemplateScalarFieldEnum)[keyof typeof PermissionInternalTemplateScalarFieldEnum]


export const PermissionInternalInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  note: 'note',
  level: 'level',
  userId: 'userId',
  permissionInternalTemplateId: 'permissionInternalTemplateId'
} as const

export type PermissionInternalInstanceScalarFieldEnum = (typeof PermissionInternalInstanceScalarFieldEnum)[keyof typeof PermissionInternalInstanceScalarFieldEnum]


export const VerificationTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  token: 'token',
  expires: 'expires'
} as const

export type VerificationTokenScalarFieldEnum = (typeof VerificationTokenScalarFieldEnum)[keyof typeof VerificationTokenScalarFieldEnum]


export const PasswordResetTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  token: 'token',
  expires: 'expires'
} as const

export type PasswordResetTokenScalarFieldEnum = (typeof PasswordResetTokenScalarFieldEnum)[keyof typeof PasswordResetTokenScalarFieldEnum]


export const LoginOtpTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  email: 'email',
  challengeId: 'challengeId',
  token: 'token',
  expires: 'expires'
} as const

export type LoginOtpTokenScalarFieldEnum = (typeof LoginOtpTokenScalarFieldEnum)[keyof typeof LoginOtpTokenScalarFieldEnum]


export const LoginAttemptScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  email: 'email',
  successful: 'successful',
  reason: 'reason'
} as const

export type LoginAttemptScalarFieldEnum = (typeof LoginAttemptScalarFieldEnum)[keyof typeof LoginAttemptScalarFieldEnum]


export const CountryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  displayName: 'displayName',
  isoName: 'isoName',
  isoNumeric: 'isoNumeric',
  alpha2Code: 'alpha2Code',
  alpha3Code: 'alpha3Code',
  regionId: 'regionId'
} as const

export type CountryScalarFieldEnum = (typeof CountryScalarFieldEnum)[keyof typeof CountryScalarFieldEnum]


export const PortScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  unlocode: 'unlocode',
  displayName: 'displayName',
  altName: 'altName',
  longitude: 'longitude',
  latitude: 'latitude',
  countryId: 'countryId'
} as const

export type PortScalarFieldEnum = (typeof PortScalarFieldEnum)[keyof typeof PortScalarFieldEnum]


export const LocationCollectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description'
} as const

export type LocationCollectionScalarFieldEnum = (typeof LocationCollectionScalarFieldEnum)[keyof typeof LocationCollectionScalarFieldEnum]


export const LocationCollectionListScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description'
} as const

export type LocationCollectionListScalarFieldEnum = (typeof LocationCollectionListScalarFieldEnum)[keyof typeof LocationCollectionListScalarFieldEnum]


export const IncoParityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description'
} as const

export type IncoParityScalarFieldEnum = (typeof IncoParityScalarFieldEnum)[keyof typeof IncoParityScalarFieldEnum]


export const ProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  category: 'category',
  group: 'group',
  name: 'name',
  density: 'density'
} as const

export type ProductScalarFieldEnum = (typeof ProductScalarFieldEnum)[keyof typeof ProductScalarFieldEnum]


export const MarketReportTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  legacyListId: 'legacyListId',
  displayName: 'displayName',
  name: 'name',
  description: 'description',
  interval: 'interval'
} as const

export type MarketReportTemplateScalarFieldEnum = (typeof MarketReportTemplateScalarFieldEnum)[keyof typeof MarketReportTemplateScalarFieldEnum]


export const MarketReportTemplateGenerationTemplateHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  addSectionToBox: 'addSectionToBox',
  additionalInformation: 'additionalInformation',
  senderEmail: 'senderEmail',
  group: 'group',
  report: 'report',
  logo: 'logo',
  subject: 'subject',
  content: 'content',
  cropTop: 'cropTop',
  cropBottom: 'cropBottom',
  footer: 'footer',
  marketReportTemplateId: 'marketReportTemplateId'
} as const

export type MarketReportTemplateGenerationTemplateHistoryScalarFieldEnum = (typeof MarketReportTemplateGenerationTemplateHistoryScalarFieldEnum)[keyof typeof MarketReportTemplateGenerationTemplateHistoryScalarFieldEnum]


export const MarketReportInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publicationDate: 'publicationDate',
  archivedAt: 'archivedAt',
  marketReportTemplateId: 'marketReportTemplateId',
  name: 'name',
  description: 'description',
  subject: 'subject',
  body: 'body'
} as const

export type MarketReportInstanceScalarFieldEnum = (typeof MarketReportInstanceScalarFieldEnum)[keyof typeof MarketReportInstanceScalarFieldEnum]


export const MarketReportPublicShareScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  token: 'token',
  marketReportInstanceId: 'marketReportInstanceId',
  createdByUserId: 'createdByUserId'
} as const

export type MarketReportPublicShareScalarFieldEnum = (typeof MarketReportPublicShareScalarFieldEnum)[keyof typeof MarketReportPublicShareScalarFieldEnum]


export const MarketReportGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  enabled: 'enabled'
} as const

export type MarketReportGroupScalarFieldEnum = (typeof MarketReportGroupScalarFieldEnum)[keyof typeof MarketReportGroupScalarFieldEnum]


export const MarketReportGroupPriorityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  priority: 'priority',
  marketReportTemplateId: 'marketReportTemplateId',
  marketReportGroupId: 'marketReportGroupId'
} as const

export type MarketReportGroupPriorityScalarFieldEnum = (typeof MarketReportGroupPriorityScalarFieldEnum)[keyof typeof MarketReportGroupPriorityScalarFieldEnum]


export const SelfCheckoutPlatformSubscriptionPriceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  price: 'price',
  currency: 'currency',
  platformSubscriptionTemplateId: 'platformSubscriptionTemplateId'
} as const

export type SelfCheckoutPlatformSubscriptionPriceScalarFieldEnum = (typeof SelfCheckoutPlatformSubscriptionPriceScalarFieldEnum)[keyof typeof SelfCheckoutPlatformSubscriptionPriceScalarFieldEnum]


export const MarketReportGroupPriceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  price: 'price',
  currency: 'currency',
  billingInterval: 'billingInterval',
  marketReportGroupId: 'marketReportGroupId'
} as const

export type MarketReportGroupPriceScalarFieldEnum = (typeof MarketReportGroupPriceScalarFieldEnum)[keyof typeof MarketReportGroupPriceScalarFieldEnum]


export const MarketReportEmailPreferenceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  marketReportGroupId: 'marketReportGroupId',
  emailEnabled: 'emailEnabled'
} as const

export type MarketReportEmailPreferenceScalarFieldEnum = (typeof MarketReportEmailPreferenceScalarFieldEnum)[keyof typeof MarketReportEmailPreferenceScalarFieldEnum]


export const NewsContentCategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description'
} as const

export type NewsContentCategoryScalarFieldEnum = (typeof NewsContentCategoryScalarFieldEnum)[keyof typeof NewsContentCategoryScalarFieldEnum]


export const MarketCommentaryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  archivedAt: 'archivedAt',
  includeInReportAt: 'includeInReportAt',
  publicationStatus: 'publicationStatus',
  visibility: 'visibility',
  body: 'body',
  createdByUserId: 'createdByUserId'
} as const

export type MarketCommentaryScalarFieldEnum = (typeof MarketCommentaryScalarFieldEnum)[keyof typeof MarketCommentaryScalarFieldEnum]


export const NewsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  archivedAt: 'archivedAt',
  includeInReportAt: 'includeInReportAt',
  publicationStatus: 'publicationStatus',
  visibility: 'visibility',
  subject: 'subject',
  body: 'body',
  createdByUserId: 'createdByUserId'
} as const

export type NewsScalarFieldEnum = (typeof NewsScalarFieldEnum)[keyof typeof NewsScalarFieldEnum]


export const MarketEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  archivedAt: 'archivedAt',
  timeOfEvent: 'timeOfEvent',
  publicationStatus: 'publicationStatus',
  visibility: 'visibility',
  subject: 'subject',
  body: 'body',
  createdByUserId: 'createdByUserId'
} as const

export type MarketEventScalarFieldEnum = (typeof MarketEventScalarFieldEnum)[keyof typeof MarketEventScalarFieldEnum]


export const ExchangeMarketScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description'
} as const

export type ExchangeMarketScalarFieldEnum = (typeof ExchangeMarketScalarFieldEnum)[keyof typeof ExchangeMarketScalarFieldEnum]


export const FutureContractInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  measurementUnitId: 'measurementUnitId',
  currecyId: 'currecyId',
  productName: 'productName',
  tickSize: 'tickSize',
  dailyLimit: 'dailyLimit',
  contractSize: 'contractSize',
  activeMonths: 'activeMonths',
  tradingHours: 'tradingHours',
  futureUnitSize: 'futureUnitSize',
  futureOptionSize: 'futureOptionSize',
  lastTradingDay: 'lastTradingDay',
  exchangeMarketId: 'exchangeMarketId'
} as const

export type FutureContractInstanceScalarFieldEnum = (typeof FutureContractInstanceScalarFieldEnum)[keyof typeof FutureContractInstanceScalarFieldEnum]


export const FutureInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  expirationDate: 'expirationDate',
  year: 'year',
  month: 'month',
  monthIdentifier: 'monthIdentifier',
  futureContractInstanceId: 'futureContractInstanceId'
} as const

export type FutureInstanceScalarFieldEnum = (typeof FutureInstanceScalarFieldEnum)[keyof typeof FutureInstanceScalarFieldEnum]


export const CurrencyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displaySymbol: 'displaySymbol',
  displayName: 'displayName',
  description: 'description',
  baseCurrencyId: 'baseCurrencyId',
  ratioToBase: 'ratioToBase'
} as const

export type CurrencyScalarFieldEnum = (typeof CurrencyScalarFieldEnum)[keyof typeof CurrencyScalarFieldEnum]


export const ExchangeRateInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  fromCurrencyId: 'fromCurrencyId',
  toCurrencyId: 'toCurrencyId',
  exchangeMarketId: 'exchangeMarketId'
} as const

export type ExchangeRateInstanceScalarFieldEnum = (typeof ExchangeRateInstanceScalarFieldEnum)[keyof typeof ExchangeRateInstanceScalarFieldEnum]


export const ProductVariantScalarFieldEnum = {
  id: 'id',
  name: 'name',
  displayName: 'displayName',
  productHierachyInstanceId: 'productHierachyInstanceId'
} as const

export type ProductVariantScalarFieldEnum = (typeof ProductVariantScalarFieldEnum)[keyof typeof ProductVariantScalarFieldEnum]


export const ProductHierachyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  superProductHierachyId: 'superProductHierachyId'
} as const

export type ProductHierachyScalarFieldEnum = (typeof ProductHierachyScalarFieldEnum)[keyof typeof ProductHierachyScalarFieldEnum]


export const ProductHierachyInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  density: 'density',
  frcId: 'frcId',
  productHierachyId: 'productHierachyId'
} as const

export type ProductHierachyInstanceScalarFieldEnum = (typeof ProductHierachyInstanceScalarFieldEnum)[keyof typeof ProductHierachyInstanceScalarFieldEnum]


export const DocumentRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName'
} as const

export type DocumentRequirementScalarFieldEnum = (typeof DocumentRequirementScalarFieldEnum)[keyof typeof DocumentRequirementScalarFieldEnum]


export const QualityRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName'
} as const

export type QualityRequirementScalarFieldEnum = (typeof QualityRequirementScalarFieldEnum)[keyof typeof QualityRequirementScalarFieldEnum]


export const BidOfferInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  timezoneOffsetFromUTC: 'timezoneOffsetFromUTC',
  expiresAt: 'expiresAt',
  closeReason: 'closeReason',
  createdByUserId: 'createdByUserId',
  d365CrmAccountId: 'd365CrmAccountId',
  legacyCrmId: 'legacyCrmId',
  bidOfferType: 'bidOfferType',
  productInstanceId: 'productInstanceId',
  proteinLevelPercentage: 'proteinLevelPercentage',
  parityId: 'parityId',
  quantityMT: 'quantityMT',
  basePortDiffId: 'basePortDiffId',
  documentRequirementId: 'documentRequirementId',
  qualityRequirementId: 'qualityRequirementId',
  showExternal: 'showExternal',
  confidentiality: 'confidentiality',
  internalNote: 'internalNote',
  externalNote: 'externalNote',
  priceType: 'priceType',
  fullTextSearchText: 'fullTextSearchText',
  fullTextSearchTextPublic: 'fullTextSearchTextPublic'
} as const

export type BidOfferInstanceScalarFieldEnum = (typeof BidOfferInstanceScalarFieldEnum)[keyof typeof BidOfferInstanceScalarFieldEnum]


export const BidOfferPremiumUpdateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  createdByUserId: 'createdByUserId',
  internalPremiumPriceInstanceId: 'internalPremiumPriceInstanceId',
  externalPremiumPriceInstanceId: 'externalPremiumPriceInstanceId',
  shipmentPeriodStart: 'shipmentPeriodStart',
  shipmentPeriodEnd: 'shipmentPeriodEnd',
  firmness: 'firmness',
  changeLog: 'changeLog',
  bidOfferInstanceId: 'bidOfferInstanceId'
} as const

export type BidOfferPremiumUpdateScalarFieldEnum = (typeof BidOfferPremiumUpdateScalarFieldEnum)[keyof typeof BidOfferPremiumUpdateScalarFieldEnum]


export const BidOfferFlatUpdateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  createdByUserId: 'createdByUserId',
  internalFlatPriceInstanceId: 'internalFlatPriceInstanceId',
  externalFlatPriceInstanceId: 'externalFlatPriceInstanceId',
  shipmentPeriodStart: 'shipmentPeriodStart',
  shipmentPeriodEnd: 'shipmentPeriodEnd',
  firmness: 'firmness',
  changeLog: 'changeLog',
  bidOfferInstanceId: 'bidOfferInstanceId'
} as const

export type BidOfferFlatUpdateScalarFieldEnum = (typeof BidOfferFlatUpdateScalarFieldEnum)[keyof typeof BidOfferFlatUpdateScalarFieldEnum]


export const PremiumPriceInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  premiumPrice: 'premiumPrice',
  futureInstanceId: 'futureInstanceId'
} as const

export type PremiumPriceInstanceScalarFieldEnum = (typeof PremiumPriceInstanceScalarFieldEnum)[keyof typeof PremiumPriceInstanceScalarFieldEnum]


export const FlatPriceInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  flatPrice: 'flatPrice',
  currencyId: 'currencyId',
  measurementUnitId: 'measurementUnitId'
} as const

export type FlatPriceInstanceScalarFieldEnum = (typeof FlatPriceInstanceScalarFieldEnum)[keyof typeof FlatPriceInstanceScalarFieldEnum]


export const MeasurementUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  type: 'type',
  name: 'name',
  displayNameLong: 'displayNameLong',
  displayNameShort: 'displayNameShort',
  ratioToBase: 'ratioToBase',
  isBase: 'isBase'
} as const

export type MeasurementUnitScalarFieldEnum = (typeof MeasurementUnitScalarFieldEnum)[keyof typeof MeasurementUnitScalarFieldEnum]


export const BasePortAreasScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  basePortId: 'basePortId',
  baseCollectionId: 'baseCollectionId'
} as const

export type BasePortAreasScalarFieldEnum = (typeof BasePortAreasScalarFieldEnum)[keyof typeof BasePortAreasScalarFieldEnum]


export const BasePortDiffScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  portId: 'portId',
  quantityLimit: 'quantityLimit',
  freightDifference: 'freightDifference',
  freightDifferenceCurrencyId: 'freightDifferenceCurrencyId',
  measurementUnitId: 'measurementUnitId'
} as const

export type BasePortDiffScalarFieldEnum = (typeof BasePortDiffScalarFieldEnum)[keyof typeof BasePortDiffScalarFieldEnum]


export const D365CrmCustomerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  accountNumber: 'accountNumber',
  accountId: 'accountId',
  accountName: 'accountName',
  country: 'country'
} as const

export type D365CrmCustomerScalarFieldEnum = (typeof D365CrmCustomerScalarFieldEnum)[keyof typeof D365CrmCustomerScalarFieldEnum]


export const NominalPriceUploadInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  archivedAt: 'archivedAt',
  jobId: 'jobId',
  userId: 'userId'
} as const

export type NominalPriceUploadInstanceScalarFieldEnum = (typeof NominalPriceUploadInstanceScalarFieldEnum)[keyof typeof NominalPriceUploadInstanceScalarFieldEnum]


export const NominalPriceInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  description: 'description',
  productInstanceId: 'productInstanceId',
  proteinLevelPercentage: 'proteinLevelPercentage',
  proteinLevelPercentageUs: 'proteinLevelPercentageUs',
  parityId: 'parityId',
  priceType: 'priceType',
  futureContractInstanceId: 'futureContractInstanceId'
} as const

export type NominalPriceInstanceScalarFieldEnum = (typeof NominalPriceInstanceScalarFieldEnum)[keyof typeof NominalPriceInstanceScalarFieldEnum]


export const NominalPricePremiumInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  premiumPrice: 'premiumPrice',
  priceDate: 'priceDate',
  futureInstanceId: 'futureInstanceId',
  nominalPriceInstanceId: 'nominalPriceInstanceId',
  nominalPriceUploadId: 'nominalPriceUploadId'
} as const

export type NominalPricePremiumInstanceScalarFieldEnum = (typeof NominalPricePremiumInstanceScalarFieldEnum)[keyof typeof NominalPricePremiumInstanceScalarFieldEnum]


export const NominalPriceFlatInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  archivedAt: 'archivedAt',
  flatPrice: 'flatPrice',
  priceDate: 'priceDate',
  currencyId: 'currencyId',
  measurementUnitId: 'measurementUnitId',
  nominalPriceInstanceId: 'nominalPriceInstanceId',
  nominalPriceUploadId: 'nominalPriceUploadId'
} as const

export type NominalPriceFlatInstanceScalarFieldEnum = (typeof NominalPriceFlatInstanceScalarFieldEnum)[keyof typeof NominalPriceFlatInstanceScalarFieldEnum]


export const FreightQuoteRequestsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  requestedById: 'requestedById',
  responsibleEmployeeId: 'responsibleEmployeeId',
  contactPhone: 'contactPhone',
  status: 'status',
  calculationId: 'calculationId',
  planId: 'planId',
  additionalComments: 'additionalComments',
  internalNote: 'internalNote',
  offeredQuotePrice: 'offeredQuotePrice',
  offeredQuoteCurrency: 'offeredQuoteCurrency',
  finalQuantity: 'finalQuantity',
  commissionAmount: 'commissionAmount',
  commissionCurrency: 'commissionCurrency',
  paramSetId: 'paramSetId',
  calcParamsHash: 'calcParamsHash'
} as const

export type FreightQuoteRequestsScalarFieldEnum = (typeof FreightQuoteRequestsScalarFieldEnum)[keyof typeof FreightQuoteRequestsScalarFieldEnum]


export const FreightQuoteRequestParamSetScalarFieldEnum = {
  id: 'id',
  vesselSize: 'vesselSize',
  freightRate: 'freightRate',
  maturityDate: 'maturityDate',
  granularity: 'granularity'
} as const

export type FreightQuoteRequestParamSetScalarFieldEnum = (typeof FreightQuoteRequestParamSetScalarFieldEnum)[keyof typeof FreightQuoteRequestParamSetScalarFieldEnum]


export const FreightQuoteRequestPortScalarFieldEnum = {
  id: 'id',
  paramSetId: 'paramSetId',
  portId: 'portId',
  order: 'order'
} as const

export type FreightQuoteRequestPortScalarFieldEnum = (typeof FreightQuoteRequestPortScalarFieldEnum)[keyof typeof FreightQuoteRequestPortScalarFieldEnum]


export const FreightQuoteRequestOperationScalarFieldEnum = {
  id: 'id',
  portId: 'portId',
  operationType: 'operationType',
  quantity: 'quantity',
  productId: 'productId',
  order: 'order'
} as const

export type FreightQuoteRequestOperationScalarFieldEnum = (typeof FreightQuoteRequestOperationScalarFieldEnum)[keyof typeof FreightQuoteRequestOperationScalarFieldEnum]


export const FreightMatrixRouteScalarFieldEnum = {
  id: 'id',
  loadPortId: 'loadPortId',
  dischargePortId: 'dischargePortId',
  productHierachyInstanceId: 'productHierachyInstanceId',
  context: 'context',
  vesselSize: 'vesselSize',
  stowageFactor: 'stowageFactor',
  stowageFactorUnit: 'stowageFactorUnit',
  loadCadence: 'loadCadence',
  loadCadenceInputType: 'loadCadenceInputType',
  loadTerms: 'loadTerms',
  loadPortDA: 'loadPortDA',
  loadPortDACurrency: 'loadPortDACurrency',
  loadUseVesselGear: 'loadUseVesselGear',
  loadDraft: 'loadDraft',
  dischargeCadence: 'dischargeCadence',
  dischargeCadenceInputType: 'dischargeCadenceInputType',
  dischargeTerms: 'dischargeTerms',
  dischargePortDA: 'dischargePortDA',
  dischargePortDACurrency: 'dischargePortDACurrency',
  dischargeUseVesselGear: 'dischargeUseVesselGear',
  dischargeDraft: 'dischargeDraft'
} as const

export type FreightMatrixRouteScalarFieldEnum = (typeof FreightMatrixRouteScalarFieldEnum)[keyof typeof FreightMatrixRouteScalarFieldEnum]


export const FreightCalculationMatrixGroupScalarFieldEnum = {
  id: 'id',
  name: 'name',
  enabled: 'enabled',
  teamId: 'teamId',
  createdAt: 'createdAt',
  algorithms: 'algorithms',
  viewMode: 'viewMode',
  draft: 'draft'
} as const

export type FreightCalculationMatrixGroupScalarFieldEnum = (typeof FreightCalculationMatrixGroupScalarFieldEnum)[keyof typeof FreightCalculationMatrixGroupScalarFieldEnum]


export const FreightCalculationMatrixGroupIncludeScalarFieldEnum = {
  groupId: 'groupId',
  includedGroupId: 'includedGroupId',
  createdAt: 'createdAt'
} as const

export type FreightCalculationMatrixGroupIncludeScalarFieldEnum = (typeof FreightCalculationMatrixGroupIncludeScalarFieldEnum)[keyof typeof FreightCalculationMatrixGroupIncludeScalarFieldEnum]


export const FreightCalculationMatrixGroupItemScalarFieldEnum = {
  matrixRouteId: 'matrixRouteId',
  matrixGroupId: 'matrixGroupId',
  createdAt: 'createdAt'
} as const

export type FreightCalculationMatrixGroupItemScalarFieldEnum = (typeof FreightCalculationMatrixGroupItemScalarFieldEnum)[keyof typeof FreightCalculationMatrixGroupItemScalarFieldEnum]


export const FreightMatrixJobScalarFieldEnum = {
  id: 'id',
  name: 'name',
  remoteId: 'remoteId',
  teamId: 'teamId'
} as const

export type FreightMatrixJobScalarFieldEnum = (typeof FreightMatrixJobScalarFieldEnum)[keyof typeof FreightMatrixJobScalarFieldEnum]


export const FreightMatrixPartialJobScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  remoteId: 'remoteId',
  finishedAt: 'finishedAt',
  teamId: 'teamId',
  userId: 'userId'
} as const

export type FreightMatrixPartialJobScalarFieldEnum = (typeof FreightMatrixPartialJobScalarFieldEnum)[keyof typeof FreightMatrixPartialJobScalarFieldEnum]


export const SelectPinnedItemScalarFieldEnum = {
  userId: 'userId',
  context: 'context',
  value: 'value'
} as const

export type SelectPinnedItemScalarFieldEnum = (typeof SelectPinnedItemScalarFieldEnum)[keyof typeof SelectPinnedItemScalarFieldEnum]


export const WhatsappConnectionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  phoneIdentifier: 'phoneIdentifier'
} as const

export type WhatsappConnectionScalarFieldEnum = (typeof WhatsappConnectionScalarFieldEnum)[keyof typeof WhatsappConnectionScalarFieldEnum]


export const NotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  notificationKey: 'notificationKey',
  userId: 'userId',
  description: 'description',
  deeplink: 'deeplink',
  metadata: 'metadata',
  type: 'type'
} as const

export type NotificationScalarFieldEnum = (typeof NotificationScalarFieldEnum)[keyof typeof NotificationScalarFieldEnum]


export const NotificationInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  deliveredAt: 'deliveredAt',
  seenAt: 'seenAt',
  channel: 'channel',
  notificationId: 'notificationId',
  externalMessadeIdentifier: 'externalMessadeIdentifier'
} as const

export type NotificationInstanceScalarFieldEnum = (typeof NotificationInstanceScalarFieldEnum)[keyof typeof NotificationInstanceScalarFieldEnum]


export const NotificationChannelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  userId: 'userId',
  channel: 'channel',
  filter: 'filter'
} as const

export type NotificationChannelScalarFieldEnum = (typeof NotificationChannelScalarFieldEnum)[keyof typeof NotificationChannelScalarFieldEnum]


export const EntityACLScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listType: 'listType',
  valueType: 'valueType',
  values: 'values',
  key: 'key',
  userId: 'userId',
  teamId: 'teamId'
} as const

export type EntityACLScalarFieldEnum = (typeof EntityACLScalarFieldEnum)[keyof typeof EntityACLScalarFieldEnum]


export const LineupAgentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  displayName: 'displayName'
} as const

export type LineupAgentScalarFieldEnum = (typeof LineupAgentScalarFieldEnum)[keyof typeof LineupAgentScalarFieldEnum]


export const CropYearDefinitionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  displayName: 'displayName',
  startMonth: 'startMonth'
} as const

export type CropYearDefinitionScalarFieldEnum = (typeof CropYearDefinitionScalarFieldEnum)[keyof typeof CropYearDefinitionScalarFieldEnum]


export const CropYearScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  displayName: 'displayName',
  definitionId: 'definitionId',
  startYear: 'startYear'
} as const

export type CropYearScalarFieldEnum = (typeof CropYearScalarFieldEnum)[keyof typeof CropYearScalarFieldEnum]


export const LineupInstanceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  createdByUserId: 'createdByUserId',
  sellerId: 'sellerId',
  buyerId: 'buyerId',
  intermediateClients: 'intermediateClients',
  broker: 'broker',
  agentId: 'agentId',
  cropYearId: 'cropYearId',
  eta: 'eta',
  blDate: 'blDate',
  status: 'status',
  vesselMarineTrafficId: 'vesselMarineTrafficId',
  vesselName: 'vesselName',
  vesselImo: 'vesselImo',
  productId: 'productId',
  proteinLevel: 'proteinLevel',
  productVariantId: 'productVariantId',
  volume: 'volume',
  loadBerth: 'loadBerth',
  loadPortId: 'loadPortId',
  dischargePortId: 'dischargePortId',
  dischargeCountryId: 'dischargeCountryId'
} as const

export type LineupInstanceScalarFieldEnum = (typeof LineupInstanceScalarFieldEnum)[keyof typeof LineupInstanceScalarFieldEnum]


export const LineupStringScalarFieldEnum = {
  lineupId: 'lineupId',
  order: 'order',
  sellerId: 'sellerId',
  buyerId: 'buyerId',
  broker: 'broker'
} as const

export type LineupStringScalarFieldEnum = (typeof LineupStringScalarFieldEnum)[keyof typeof LineupStringScalarFieldEnum]


export const LineupHistoryScalarFieldEnum = {
  id: 'id',
  lineupId: 'lineupId',
  changedAt: 'changedAt',
  status: 'status',
  eta: 'eta',
  blDate: 'blDate',
  volume: 'volume',
  updatedByUserId: 'updatedByUserId'
} as const

export type LineupHistoryScalarFieldEnum = (typeof LineupHistoryScalarFieldEnum)[keyof typeof LineupHistoryScalarFieldEnum]


export const DataJobsScalarFieldEnum = {
  id: 'id',
  startedAt: 'startedAt',
  finishedAt: 'finishedAt',
  jobType: 'jobType',
  backendId: 'backendId',
  status: 'status',
  progress: 'progress',
  error: 'error'
} as const

export type DataJobsScalarFieldEnum = (typeof DataJobsScalarFieldEnum)[keyof typeof DataJobsScalarFieldEnum]


export const FeatureFlagsScalarFieldEnum = {
  flagKey: 'flagKey',
  active: 'active',
  disabled: 'disabled',
  defaultValue: 'defaultValue',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureFlagsScalarFieldEnum = (typeof FeatureFlagsScalarFieldEnum)[keyof typeof FeatureFlagsScalarFieldEnum]


export const FeatureFlagTeamTargetScalarFieldEnum = {
  id: 'id',
  flagKey: 'flagKey',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureFlagTeamTargetScalarFieldEnum = (typeof FeatureFlagTeamTargetScalarFieldEnum)[keyof typeof FeatureFlagTeamTargetScalarFieldEnum]


export const FeatureFlagUserTargetScalarFieldEnum = {
  id: 'id',
  flagKey: 'flagKey',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type FeatureFlagUserTargetScalarFieldEnum = (typeof FeatureFlagUserTargetScalarFieldEnum)[keyof typeof FeatureFlagUserTargetScalarFieldEnum]


export const PaymentCustomerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  userId: 'userId',
  email: 'email',
  name: 'name',
  providerCustomerId: 'providerCustomerId'
} as const

export type PaymentCustomerScalarFieldEnum = (typeof PaymentCustomerScalarFieldEnum)[keyof typeof PaymentCustomerScalarFieldEnum]


export const SelfCheckoutSubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  customerId: 'customerId',
  status: 'status',
  currentPeriodStart: 'currentPeriodStart',
  currentPeriodEnd: 'currentPeriodEnd',
  billingCycleAnchor: 'billingCycleAnchor',
  cancelAtPeriodEnd: 'cancelAtPeriodEnd',
  canceledAt: 'canceledAt',
  cancelReason: 'cancelReason',
  subscriptionType: 'subscriptionType',
  currentPrice: 'currentPrice',
  currentCurrency: 'currentCurrency',
  trialStart: 'trialStart',
  trialEnd: 'trialEnd',
  trialConvertedAt: 'trialConvertedAt',
  version: 'version'
} as const

export type SelfCheckoutSubscriptionScalarFieldEnum = (typeof SelfCheckoutSubscriptionScalarFieldEnum)[keyof typeof SelfCheckoutSubscriptionScalarFieldEnum]


export const SelfCheckoutSubscriptionItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  subscriptionId: 'subscriptionId',
  marketReportGroupPriceId: 'marketReportGroupPriceId',
  platformSubscriptionPriceId: 'platformSubscriptionPriceId'
} as const

export type SelfCheckoutSubscriptionItemScalarFieldEnum = (typeof SelfCheckoutSubscriptionItemScalarFieldEnum)[keyof typeof SelfCheckoutSubscriptionItemScalarFieldEnum]


export const SubscriptionChangeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  subscriptionId: 'subscriptionId',
  changeType: 'changeType',
  previousPrice: 'previousPrice',
  previousType: 'previousType',
  newPrice: 'newPrice',
  newType: 'newType',
  prorationAmount: 'prorationAmount',
  prorationCurrency: 'prorationCurrency',
  immediateCharge: 'immediateCharge',
  effectiveDate: 'effectiveDate',
  appliedAt: 'appliedAt',
  changedByUserId: 'changedByUserId',
  note: 'note'
} as const

export type SubscriptionChangeScalarFieldEnum = (typeof SubscriptionChangeScalarFieldEnum)[keyof typeof SubscriptionChangeScalarFieldEnum]


export const PaymentProviderProductMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  provider: 'provider',
  productType: 'productType',
  marketReportGroupPriceId: 'marketReportGroupPriceId',
  platformSubscriptionPriceId: 'platformSubscriptionPriceId',
  providerProductId: 'providerProductId',
  providerPriceId: 'providerPriceId',
  isActive: 'isActive',
  metadata: 'metadata'
} as const

export type PaymentProviderProductMappingScalarFieldEnum = (typeof PaymentProviderProductMappingScalarFieldEnum)[keyof typeof PaymentProviderProductMappingScalarFieldEnum]


export const PaymentProviderSubscriptionDataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subscriptionId: 'subscriptionId',
  provider: 'provider',
  providerSubscriptionId: 'providerSubscriptionId',
  providerStatus: 'providerStatus',
  metadata: 'metadata'
} as const

export type PaymentProviderSubscriptionDataScalarFieldEnum = (typeof PaymentProviderSubscriptionDataScalarFieldEnum)[keyof typeof PaymentProviderSubscriptionDataScalarFieldEnum]


export const PaymentProviderWebhookEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  processedAt: 'processedAt',
  provider: 'provider',
  providerEventId: 'providerEventId',
  eventType: 'eventType',
  payload: 'payload',
  status: 'status',
  processingError: 'processingError',
  retryCount: 'retryCount',
  maxRetries: 'maxRetries',
  nextRetryAt: 'nextRetryAt',
  processedResult: 'processedResult',
  customerId: 'customerId',
  subscriptionId: 'subscriptionId',
  invoiceId: 'invoiceId',
  paymentId: 'paymentId',
  eventTimestamp: 'eventTimestamp',
  receivedAt: 'receivedAt',
  signature: 'signature',
  signatureVerified: 'signatureVerified',
  verifiedAt: 'verifiedAt'
} as const

export type PaymentProviderWebhookEventScalarFieldEnum = (typeof PaymentProviderWebhookEventScalarFieldEnum)[keyof typeof PaymentProviderWebhookEventScalarFieldEnum]


export const AuditLogScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  action: 'action',
  entityType: 'entityType',
  entityId: 'entityId',
  changes: 'changes',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  metadata: 'metadata',
  createdAt: 'createdAt'
} as const

export type AuditLogScalarFieldEnum = (typeof AuditLogScalarFieldEnum)[keyof typeof AuditLogScalarFieldEnum]


export const FormSubmissionsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  pageId: 'pageId',
  blockId: 'blockId',
  pageTitle: 'pageTitle',
  formSubmission: 'formSubmission',
  email: 'email',
  handled: 'handled',
  handledAt: 'handledAt',
  handledByBot: 'handledByBot'
} as const

export type FormSubmissionsScalarFieldEnum = (typeof FormSubmissionsScalarFieldEnum)[keyof typeof FormSubmissionsScalarFieldEnum]


export const SupplyDemandScalarFieldEnum = {
  id: 'id',
  countryId: 'countryId',
  productId: 'productId',
  attributeId: 'attributeId',
  marketYear: 'marketYear',
  value: 'value',
  isComputed: 'isComputed',
  supplyDemandUploadId: 'supplyDemandUploadId'
} as const

export type SupplyDemandScalarFieldEnum = (typeof SupplyDemandScalarFieldEnum)[keyof typeof SupplyDemandScalarFieldEnum]


export const SupplyDemandAttributeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  displayName: 'displayName',
  shortDisplayName: 'shortDisplayName',
  description: 'description',
  measurementUnitId: 'measurementUnitId',
  countryGroup: 'countryGroup',
  tableRowPosition: 'tableRowPosition'
} as const

export type SupplyDemandAttributeScalarFieldEnum = (typeof SupplyDemandAttributeScalarFieldEnum)[keyof typeof SupplyDemandAttributeScalarFieldEnum]


export const SupplyDemandUploadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishedAt: 'publishedAt',
  archivedAt: 'archivedAt',
  jobId: 'jobId',
  userId: 'userId'
} as const

export type SupplyDemandUploadScalarFieldEnum = (typeof SupplyDemandUploadScalarFieldEnum)[keyof typeof SupplyDemandUploadScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]

